// removed by extract-text-webpack-plugin
module.exports = {"wrapper-box-shadow":"magazines_3XEiP","wrapper-box-shadow__divider":"magazines_25Mnf","wrapper-box-shadow__button-color":"magazines_lgGHR","wrapper-box-shadow__content-slider":"magazines_1M549","popover":"magazines_2dD8c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/BoxShadow/styles.scss
// module id = 1219
// module chunks = 1